import React, { useState, useEffect, useRef } from 'react'
import { useLocation, useNavigate } from 'react-router-dom';
import FeedSidebar from './FeedSidebar';
import NewAvailable from './NewAvailable';
import FeedRecived from './FeedRecived';
import FeedsRequested from './FeedsRequested';
import MyFeedShared from './MyFeedShared';
import MyFeedProposed from './MyFeedProposed';
import MyFeedActive from './MyFeedActive';
import IncomingMemberFeed from './IncomingMemberFeed';
import ViewMyShared from './ViewMyShared';
import ConnectionFeedSettings from './ConnectionFeedSettings';
import ConnectionFeedSettingsDetails from './ConnectionFeedSettingsDetails';
import { buildMyFeedActiveSubRouteState, isMyFeedActiveSubRoute } from '../utils/feedActiveNavigation';
import baseURL from '../component/baseURL';

export default function Feed() {

    const location = useLocation();
    const navigate = useNavigate();
    const [activeItem, setActiveItem] = useState("New Available");
    const [isMobilePageOpen, setIsMobilePageOpen] = useState(false);
    const [isMobile, setIsMobile] = useState(false);
    const [gearMenuOpen, setGearMenuOpen] = useState(false);
    const [gearSpinning, setGearSpinning] = useState(false);
    const gearMenuRef = useRef(null);
    const feedItemToMobilePath = {
        'Feed 1': '/feed/my-feed-active/feed-1',
        'Feed 2': '/feed/my-feed-active/feed-2',
        'Feed 3': '/feed/my-feed-active/feed-3',
        'Feed 4': '/feed/my-feed-active/feed-4',
        'Feed 5': '/feed/my-feed-active/feed-5',
        'Pocket Feed': '/feed/my-feed-active/pocket-feed',
    };


    useEffect(() => {
        const checkMobile = () => {
            setIsMobile(window.innerWidth <= 767);
        };

        checkMobile();
        window.addEventListener('resize', checkMobile);

        return () => window.removeEventListener('resize', checkMobile);
    }, []);

    useEffect(() => {
        if (!isMobile) return undefined;

        const wrapper = document.querySelector('.content-right-wrapper');
        const contentRight = wrapper?.querySelector('.content-right');
        if (!contentRight) return undefined;

        contentRight.classList.add('feed-page');

        return () => {
            contentRight.classList.remove('feed-page');
        };
    }, [isMobile, activeItem, isMobilePageOpen, location.pathname]);

    useEffect(() => {
        const userID = localStorage.getItem('user_id');


    }, []);

    // Close gear dropdown on outside click (desktop)
    useEffect(() => {
        const handleGearClickOutside = (e) => {
            if (gearMenuRef.current && !gearMenuRef.current.contains(e.target)) {
                setGearMenuOpen(false);
            }
        };
        document.addEventListener('mousedown', handleGearClickOutside);
        document.addEventListener('touchstart', handleGearClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleGearClickOutside);
            document.removeEventListener('touchstart', handleGearClickOutside);
        };
    }, []);

    const handleGearFeedNavigate = (feedItem) => {
        setGearMenuOpen(false);
        if (isMobile && feedItemToMobilePath[feedItem]) {
            navigate(feedItemToMobilePath[feedItem], {
                state: buildMyFeedActiveSubRouteState(feedItem, location.state?.returnTo),
            });
            return;
        }
        navigate('/feed/my-feed-active', { state: { activeItem: feedItem } });
    };

    const handleItemClick = (item) => {
        setActiveItem(item);

        // Update URL for mobile routes (used for header hide + deep-linking)
        if (item === 'Feeds Received') {
            navigate('/feed/feed-recived', { replace: true });
        } else if (item === 'Feeds Requested') {
            navigate('/feed/feeds-requested', { replace: true });
        } else if (item === 'My Feed Shared') {
            navigate('/feed/my-feed-shared', { replace: true });
        } else if (item === 'My Feed Proposed') {
            navigate('/feed/my-feed-proposed', { replace: true });
        } else if (item === 'My Feed Active') {
            navigate('/feed/my-feed-active', {
                replace: true,
                state: {
                    returnTo: location.state?.returnTo ?? { path: '/feed', state: {} },
                },
            });
        } else if (item === 'New Available') {
            navigate('/feed/new-available', { replace: true });
        }

        // Notify App component about MyConnection view
        const isViewingMyConnection = item === "New Available";
        window.dispatchEvent(new CustomEvent('myConnectionView', {
            detail: { isViewing: isViewingMyConnection }
        }));

        if (isMobile) {
            setIsMobilePageOpen(true);
        }
    };

    // Notify on initial load
    useEffect(() => {
        const isViewingMyConnection = activeItem === "New Available";
        window.dispatchEvent(new CustomEvent('myConnectionView', {
            detail: { isViewing: isViewingMyConnection }
        }));
    }, [activeItem]);

    // Set initial tab when coming from other pages (e.g. MembersProfile back from Feeds Received)
    useEffect(() => {
        const fromState = location.state;
        if (fromState?.activeItem) {
            setActiveItem(fromState.activeItem);
            if (isMobile) {
                setIsMobilePageOpen(true);
            }
        }
    }, [location.state, isMobile]);

    // Sync activeItem from mobile routes
    useEffect(() => {
        const path = location.pathname;
        if (path === '/feed/new-available') {
            setActiveItem('New Available');
            if (isMobile) setIsMobilePageOpen(true);
        } else if (path === '/feed/feed-recived') {
            setActiveItem('Feeds Received');
            if (isMobile) setIsMobilePageOpen(true);
        } else if (path === '/feed/feeds-requested') {
            setActiveItem('Feeds Requested');
            if (isMobile) setIsMobilePageOpen(true);
        } else if (path === '/feed/my-feed-shared') {
            setActiveItem('My Feed Shared');
            if (isMobile) setIsMobilePageOpen(true);
        } else if (path === '/feed/my-feed-proposed') {
            setActiveItem('My Feed Proposed');
            if (isMobile) setIsMobilePageOpen(true);
        } else if (path === '/feed/my-feed-active') {
            setActiveItem('My Feed Active');
            if (isMobile) setIsMobilePageOpen(true);
        } else if (
            path === '/feed/my-feed-active/feed-1' ||
            path === '/feed/my-feed-active/feed-2' ||
            path === '/feed/my-feed-active/feed-3' ||
            path === '/feed/my-feed-active/feed-4' ||
            path === '/feed/my-feed-active/feed-5' ||
            path === '/feed/my-feed-active/pocket-feed'
        ) {
            setActiveItem('My Feed Active');
            if (isMobile) setIsMobilePageOpen(true);
        } else if (path === '/feed/incoming-member-feed') {
            setActiveItem('Incoming Member Feed');
            if (isMobile) setIsMobilePageOpen(true);
        } else if (path === '/feed/view-my-shared') {
            setActiveItem('View My Shared');
            if (isMobile) setIsMobilePageOpen(true);
        } else if (path === '/feed/connection-feed-settings') {
            setActiveItem('Connection Feed Settings');
            if (isMobile) setIsMobilePageOpen(true);
        } else if (path === '/feed/connection-feed-settings-details') {
            setActiveItem('Connection Feed Settings Details');
            if (isMobile) setIsMobilePageOpen(true);
        } else if ((path === '/feed' || path === '/feed/') && !location.state?.activeItem) {
            setActiveItem('New Available');
            if (isMobile) setIsMobilePageOpen(false);
        }
    }, [location.pathname, location.state?.activeItem, isMobile]);

    const applyFeedReturnToBack = () => {
        const returnTo = location.state?.returnTo;
        if (!returnTo?.path) {
            return false;
        }
        navigate(returnTo.path, { replace: true, state: returnTo.state ?? {} });
        const isFeedHub = returnTo.path === '/feed' || returnTo.path === '/feed/';
        setIsMobilePageOpen(!isFeedHub);
        return true;
    };

    const handleBackClick = () => {
        if (applyFeedReturnToBack()) {
            return;
        }
        setIsMobilePageOpen(false);
        if (isMyFeedActiveSubRoute(location.pathname)) {
            navigate('/feed/my-feed-active', {
                replace: true,
                state: location.state?.returnTo?.state ?? {},
            });
            return;
        }
        if (location.pathname === '/feed/my-feed-active') {
            navigate('/feed', { replace: true, state: {} });
            return;
        }
        if (location.pathname === '/feed/connection-feed-settings-details') {
            navigate('/feed/connection-feed-settings', { replace: true, state: location.state?.returnTo?.state ?? {} });
            return;
        }
        if (location.pathname === '/feed/connection-feed-settings') {
            navigate('/feed', { replace: true });
            return;
        }
        // Update URL to /feed so mobile header shows (header hidden on /feed/* mobile subroutes)
        if (location.pathname !== '/feed' && location.pathname !== '/feed/') {
            navigate('/feed', { replace: true });
        }
    };

    const handleMobileHeaderBack = () => {
        if (applyFeedReturnToBack()) {
            return;
        }
        if (isMobilePageOpen) {
            handleBackClick();
            return;
        }
        navigate('/home');
    };






    const renderContent = () => {
        switch (activeItem) {
            case "New Available":
                return <NewAvailable />;
            case "Feeds Received":
                return <FeedRecived />;
            case "Feeds Requested":
                return <FeedsRequested />;
            case "My Feed Shared":
                return <MyFeedShared />;
            case "My Feed Proposed":
                return <MyFeedProposed />;
            case "My Feed Active":
                return <MyFeedActive />;
            case "Incoming Member Feed":
                return <IncomingMemberFeed />;
            case "View My Shared":
                return <ViewMyShared />;
            case "Connection Feed Settings":
                return <ConnectionFeedSettings />;
            case "Connection Feed Settings Details":
                return <ConnectionFeedSettingsDetails />;
            default:
                return <NewAvailable />;
        }
    };

    const isMyFeedActiveDesktop = !isMobile && location.pathname.startsWith('/feed/my-feed-active');
    const showFeedSidebar = !isMyFeedActiveDesktop;
    const isDedicatedMyFeedActiveRoute = isMyFeedActiveSubRoute(location.pathname);

    return (
        <section className="home">
            <div className={`container ${isMobile ? 'feed-page-container-mobile' : ''}`}>
                {isMobile &&
                    activeItem !== 'My Feed Shared' &&
                    activeItem !== 'My Feed Proposed' &&
                    !isDedicatedMyFeedActiveRoute && (
                    <div className="mobile-page-header">
                        <button type="button" className="mobile-back-btn" onClick={handleMobileHeaderBack} aria-label="Back">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                <path d="M15 18L9 12L15 6" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                        </button>
                        <h2 className="mobile-page-title">{isMobilePageOpen ? activeItem : 'Feed'}</h2>
                    </div>
                )}
                <div
                    className={`content-holder${isMyFeedActiveDesktop ? ' my-feed-active-layout' : ''}`}
                    style={isMyFeedActiveDesktop ? { gridTemplateColumns: '1fr' } : undefined}
                >
                    {isMyFeedActiveDesktop ? (
                        <MyFeedActive hideMobileHeader />
                    ) : (
                        <>
                            {showFeedSidebar && (
                                <FeedSidebar
                                    activeItem={activeItem}
                                    setActiveItem={handleItemClick}
                                />
                            )}
                            <div className={`content-right-wrapper ${isMobilePageOpen ? 'mobile-page-open' : ''}`}>
                                {renderContent()}
                            </div>
                        </>
                    )}

                    {/* Desktop only: gear icon with dropdown (Feed filters) — hide on Feeds Received / View My Shared; those views have their own gear */}
                    {!isMobile &&
                        !isMyFeedActiveDesktop &&
                        activeItem !== 'Feeds Received' &&
                        activeItem !== 'New Available' &&
                        activeItem !== 'Connection Feed Settings' &&
                        activeItem !== 'Connection Feed Settings Details' &&
                        activeItem !== 'Incoming Member Feed' &&
                        activeItem !== 'My Feed Proposed' &&
                        activeItem !== 'View My Shared' && (
                            <div className="btn-section btn-section-gear" ref={gearMenuRef}>
                                <button
                                    type="button"
                                    className={`btn-primary gear-btn ${gearSpinning ? 'gear-spin' : ''}`}
                                    onClick={() => {
                                        setGearMenuOpen((prev) => !prev);
                                        setGearSpinning(true);
                                        setTimeout(() => setGearSpinning(false), 500);
                                    }}
                                    aria-label="Feed options"
                                    aria-expanded={gearMenuOpen}
                                >
                                    <i className="fa-solid fa-gear"></i>
                                </button>
                                {gearMenuOpen && (
                                    <ul className="gear-dropdown" aria-label="Feed options list">
                                        <li>
                                            <button
                                                type="button"
                                                className="gear-dropdown-item"
                                                onClick={() => handleGearFeedNavigate('Feed 1')}
                                            >
                                                <span>Feed 1</span>
                                            </button>
                                        </li>
                                        <li>
                                            <button
                                                type="button"
                                                className="gear-dropdown-item"
                                                onClick={() => handleGearFeedNavigate('Feed 2')}
                                            >
                                                <span>Feed 2</span>
                                            </button>
                                        </li>
                                        <li>
                                            <button
                                                type="button"
                                                className="gear-dropdown-item"
                                                onClick={() => handleGearFeedNavigate('Feed 3')}
                                            >
                                                <span>Feed 3</span>
                                            </button>
                                        </li>
                                        <li>
                                            <button
                                                type="button"
                                                className="gear-dropdown-item"
                                                onClick={() => handleGearFeedNavigate('Feed 4')}
                                            >
                                                <span>Feed 4</span>
                                            </button>
                                        </li>
                                        <li>
                                            <button
                                                type="button"
                                                className="gear-dropdown-item"
                                                onClick={() => handleGearFeedNavigate('Feed 5')}
                                            >
                                                <span>Feed 5</span>
                                            </button>
                                        </li>
                                        <li>
                                            <button
                                                type="button"
                                                className="gear-dropdown-item"
                                                onClick={() => handleGearFeedNavigate('Pocket Feed')}
                                            >
                                                <span>Pocket Feed</span>
                                            </button>
                                        </li>
                                    </ul>
                                )}
                            </div>
                        )}

                    {isMobile &&
                        activeItem !== 'My Feed Active' &&
                        activeItem !== 'Feeds Received' &&
                        activeItem !== 'New Available' &&
                        activeItem !== 'Connection Feed Settings' &&
                        activeItem !== 'Connection Feed Settings Details' &&
                        activeItem !== 'Incoming Member Feed' &&
                        activeItem !== 'My Feed Proposed' &&
                        activeItem !== 'View My Shared' && (
                            <nav className="mobile-bottom-nav liquidGlass-wrapper dock feed-mobile-bottom-nav" aria-label="Feed options">
                                <div className="liquidGlass-effect" aria-hidden="true" />
                                <div className="liquidGlass-shine" aria-hidden="true" />
                                <div className="mobile-nav-item" role="button" tabIndex={0} aria-label="Feed 1" onClick={() => handleGearFeedNavigate('Feed 1')}>
                                    <i className="fa-solid fa-1"></i>
                                </div>
                                <div className="mobile-nav-item" role="button" tabIndex={0} aria-label="Feed 2" onClick={() => handleGearFeedNavigate('Feed 2')}>
                                    <i className="fa-solid fa-2"></i>
                                </div>
                                <div className="mobile-nav-item" role="button" tabIndex={0} aria-label="Feed 3" onClick={() => handleGearFeedNavigate('Feed 3')}>
                                    <i className="fa-solid fa-3"></i>
                                </div>
                                <div className="mobile-nav-item" role="button" tabIndex={0} aria-label="Feed 4" onClick={() => handleGearFeedNavigate('Feed 4')}>
                                    <i className="fa-solid fa-4"></i>
                                </div>
                                <div className="mobile-nav-item" role="button" tabIndex={0} aria-label="Feed 5" onClick={() => handleGearFeedNavigate('Feed 5')}>
                                    <i className="fa-solid fa-5"></i>
                                </div>
                                <div className="mobile-nav-item" role="button" tabIndex={0} aria-label="Pocket Feed" onClick={() => handleGearFeedNavigate('Pocket Feed')}>
                                    <i className="fa-solid fa-briefcase"></i>
                                </div>
                            </nav>
                        )}
                </div>
            </div>
        </section>
    )
}